import { z, type ZodType } from 'zod';
import { Country } from './Country';

/** Zod schema to validate {@link Country} values which can be in any case. */
export const CountrySchema = z.preprocess(
  (value) => (typeof value === 'string' ? value.toUpperCase() : value),
  z.nativeEnum(Country)
) as ZodType<Country>;
